/**
 * Newsletter Modal Alpine Component
 *
 * Triggers the newsletter sign-up modal after 30 seconds OR 50% scroll depth,
 * whichever comes first. Uses localStorage to ensure the modal is only ever
 * shown once per browser (dismissed users are never prompted again).
 *
 * Trigger conditions (first to fire wins):
 *   • 30-second timer  — catches users who stay on one screen without scrolling
 *   • 50% scroll depth — catches engaged readers who scroll before 30s is up
 *
 * The visual modal is defined in '_components/global/newsletter-modal.twig'
 * and opened via the shared modal:open event.
 */
export default function NewsletterModal() {
  return {
    STORAGE_KEY: 'fanuc_newsletter_shown',

    init() {
      // Already seen — do nothing
      if (localStorage.getItem(this.STORAGE_KEY)) return;

      let fired = false;

      const fire = () => {
        if (fired) return;
        fired = true;
        clearTimeout(timer);
        window.removeEventListener('scroll', onScroll);
        this.trigger();
      };

      // Condition 1: 30-second timer
      const timer = setTimeout(fire, 30_000);

      // Condition 2: 50% scroll depth
      const onScroll = () => {
        const scrolled = window.scrollY + window.innerHeight;
        const total = document.documentElement.scrollHeight;
        if (scrolled / total >= 0.5) fire();
      };
      window.addEventListener('scroll', onScroll, { passive: true });
    },

    trigger() {
      // Mark as shown immediately so refreshes / back-navigation never re-trigger
      localStorage.setItem(this.STORAGE_KEY, '1');

      window.dispatchEvent(
        new CustomEvent('modal:open', {
          detail: { id: 'newsletter-modal', size: 'md' },
        }),
      );
    },
  };
}
